import { useState } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";

// styled components
import { Radio, Typography } from "antd";

import PersonaNatural from "./component/PersonaNatural";
import PersonalJuridica from "./component/PersonaJuridica";
// import Continuar from "./component/Continuar";
// import { useHistory } from "react-router-dom";
import { BannerPanelRegistroUsuarios } from "../components/BannerPanelRegistroUsuarios";
import { Footer } from "../../../components/Landing/Footer";

export const RegistrarUsuario = () => {
  const { Text, Paragraph } = Typography;
  const [value, setValue] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  const onChange = (e: any) => {
    setValue(e.target.value);
  };

  function onChanges(e: any) {
    return setIsComplete(e.target.checked);
  }

  return (
    <div>
      <Header />
      <BannerPanelRegistroUsuarios />

      <div className="container-fluid2"
        style={{
          minHeight: 450
        }}
      >

        <div
          className="row"

        >
          {value !== 3 && (
            <>
              <div className="col-12"
                style={{
                  borderBottom: "0.1px solid #a9a9a9",
                  paddingBottom: 10,
                }}
              >
                <div className="row mt-3"


                >
                  <Paragraph
                    style={{
                      fontSize: 17,
                    }}
                    className="font-family-Montserrat-Regular"
                  >
                    <span className="font-family-Montserrat-Bold">
                      Completa el formulario de registro para participar en las convocatorias.
                    </span>{" "}
                      Recuerda diligenciar los campos que son obligatorios para completar el registro exitosamente.
                  </Paragraph>
                </div>
                {<Text className="font-size-18px font-family-Montserrat-Regular">Formulario de registro</Text>}
              </div>
              <Text className="radio_label_regi font-family-Monserrat-SemiBold py-4 font-color-535353">Tipo de sociedad</Text>
              <div className="col-12 btn_con_re">
                <Radio.Group onChange={onChange} style={{}} value={value}>
                  <Radio className="font-family-Monserrat-Regular" value={1}>Persona natural</Radio>
                  <Radio value={2}>Persona jurídica</Radio>
                </Radio.Group>
              </div>
            </>
          )}
          <div className="col-12 pt-4 pb-4">
            {value === 1 ? (
              <PersonaNatural isComplete={isComplete} />
            ) : value === 2 ? (
              <PersonalJuridica />
            ) : (
              value === 3
            )}
          </div>
        </div>
      </div>
      < Footer />
    </div>
  );
};
